// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m9-3";
export var downloadButton = "_m9-4";
export var fileContainer = "_m9-9 _m9-7";
export var fileContainerBase = "_m9-7";
export var fileContainerFixedHeight = "_m9-8 _m9-7";
export var fileInfo = "_m9-5";
export var fileInfoWidthRestricted = "_m9-6";
export var fileType = "_m9-1";
export var fileTypeName = "_m9-2";
export var image = "_m9-0";
export var link = "_m9-b";
export var overflowEllipsis = "_m9-a";